import Swal from 'sweetalert2';


export const showConfirm = async ({
  title = 'Konfirmasi',
  text = 'Apakah Anda yakin?',
  confirmButtonText = 'Ya',
  cancelButtonText = 'Batal',
  icon = 'warning'
}) => {
  const result = await Swal.fire({
    title,
    text,
    icon,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText,
    cancelButtonText,
    reverseButtons: true
  });

  return result.isConfirmed;
};


export const showSuccess = (message = 'Berhasil!', title = 'Sukses') => {
  Swal.fire({
    icon: 'success',
    title,
    text: message,
    timer: 2000,
    showConfirmButton: false
  });
};


export const showError = (message = 'Terjadi kesalahan', title = 'Gagal') => {
  Swal.fire({
    icon: 'error',
    title,
    text: message,
    timer: 2500,
    showConfirmButton: false
  });
};
